import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { handleOAuthCallback, setPrivateSearchEnabled } from './auth';
import './PrivateSearch.css';

const OAuthCallback = ({ history, location }) => {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing OAuth callback...');

  useEffect(() => {
    const processCallback = async () => {
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');
      const errorDescription = urlParams.get('error_description');

      if (error) {
        setStatus('error');
        setMessage(`OAuth error: ${error}${errorDescription ? ` - ${errorDescription}` : ''}`);
        return;
      }

      if (!code) {
        setStatus('error');
        setMessage('No authorization code received from Bangumi');
        return;
      }

      try {
        const result = await handleOAuthCallback(code);
        
        if (result.success) {
          setStatus('success');
          setMessage('Authentication successful! Redirecting back...');
          
          // Enable private search since user just completed OAuth
          setPrivateSearchEnabled(true);
          
          // Redirect back to the page that initiated OAuth (stored in localStorage)
          const returnUrl = localStorage.getItem('oauthReturnUrl') || '/';
          setTimeout(() => {
            history.push(returnUrl);
            // Clean up the stored return URL
            localStorage.removeItem('oauthReturnUrl');
          }, 2000);
        } else {
          setStatus('error');
          setMessage(`Authentication failed: ${result.error}`);
        }
      } catch (error) {
        setStatus('error');
        setMessage(`Authentication error: ${error.message}`);
      }
    };

    processCallback();
  }, [location.search, location.pathname, history]);

  const getStatusIcon = () => {
    switch (status) {
      case 'processing':
        return '⏳';
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      default:
        return '⏳';
    }
  };


  return (
    <div className="oauth-callback-container">
      <div className="oauth-callback-card">
        <div className="oauth-callback-icon">
          {getStatusIcon()}
        </div>
        
        <h2 className={`oauth-callback-title ${status}`}>
          {status === 'processing' && 'Processing...'}
          {status === 'success' && 'Success!'}
          {status === 'error' && 'Error'}
        </h2>
        
        <p className="oauth-callback-message">
          {message}
        </p>
        
        {status === 'error' && (
          <button
            onClick={() => history.push('/')}
            className="oauth-callback-button"
          >
            Return to Search
          </button>
        )}
      </div>
    </div>
  );
};

export default withRouter(OAuthCallback);
